import { Typography } from '@snack-uikit/typography';
import cn from 'classnames';
import Link from 'next/link';
import { FC, HTMLAttributeAnchorTarget, MouseEventHandler, PropsWithChildren, ReactNode } from 'react';

import s from './styles.module.scss';

type BaseLinkWrapperProps = {
  link?: string;
  textWrapper?: FC<{ children: ReactNode; 'data-test-id'?: string }>;
  externalOnClickLink?: MouseEventHandler<HTMLAnchorElement>;
  'data-test-id'?: string;
  passHref?: boolean;
  linkCN?: string;
  target?: HTMLAttributeAnchorTarget;
};
type LinkWrapperProps = PropsWithChildren<BaseLinkWrapperProps>;

export function LinkWrapper({
  link,
  children,
  textWrapper,
  externalOnClickLink,
  passHref,
  linkCN,
  target,
  ...rest
}: LinkWrapperProps) {
  const Wrapper = textWrapper || Typography.LightLabelM;

  if (link) {
    return (
      <Link target={target} onClick={externalOnClickLink} className={cn(s.link, linkCN)} href={link}>
        <Wrapper>{children}</Wrapper>
      </Link>
    );
  }
  return (
    <Typography.LightLabelM data-test-id={rest['data-test-id']} className={s.current_route}>
      {children}
    </Typography.LightLabelM>
  );
}
